export default "__VITE_ASSET__C_Kc0CXC__"